import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getNotesPurchaseListCallSCountersApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.GET_NOTES_PURCHASE_LIST_CALLS_COUNTERS,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response.data)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
